export const LOAD_MESSAGE_TYPES_REQUEST = 'LOAD_MESSAGE_TYPES';
export const LOAD_MESSAGE_TYPES_SUCCESS = 'LOAD_MESSAGE_TYPES_SUCCESS';
export const LOAD_MESSAGE_TYPES_FAILURE = 'LOAD_MESSAGE_TYPES_FAILURE';
export const SEARCH_MESSAGES_PENDING = 'SEARCH_MESSAGES_PENDING';
export const SEARCH_MESSAGE_SUCCESS = 'SEARCH_MESSAGE_SUCCESS';
export const SEARCH_MESSAGE_FAILURE = 'SEARCH_MESSAGE_FAILURE';
export const SEARCH_MESSAGE_RESET = 'SEARCH_MESSAGE_RESET';
export const LOAD_EMAIL_REQUEST = 'LOAD_EMAIL_REQUEST';
export const LOAD_EMAIL_SUCCESS = 'LOAD_EMAIL_SUCCESS';
export const LOAD_EMAIL_FAILURE = 'LOAD_EMAIL_FAILURE';
export const RESET_LOAD_EMAIL_REQUEST = 'RESET_LOAD_EMAIL_REQUEST';
export const LOAD_EMAIL_PREVIEW_REQUEST = 'LOAD_EMAIL_PREVIEW_REQUEST';
export const LOAD_EMAIL_PREVIEW_SUCCESS = 'LOAD_EMAIL_PREVIEW_SUCCESS';
export const LOAD_EMAIL_PREVIEW_FAILURE = 'LOAD_EMAIL_PREVIEW_FAILURE';
export const CLEAR_SELECTED_EMAIL = 'CLEAR_SELECTED_EMAIL';
export const SET_EMAIL_ID = 'SET_EMAIL_ID';
export const STORE_SEARCH_VALUES = 'STORE_SEARCH_VALUES';
export const STORE_PAGINATION = 'STORE_PAGINATION';
